/*
<label>
  <Checkbox
    checked={checked}                       // Boolean, Check State
    onChange={handleCheckboxChange}         // Function to change the state
  />
  <span></span>   // Label Text (span tag is required for the styling)
</label>
*/
import React from "react";
import styled from "styled-components";

const Checkbox = ({
  className,
  checked,
  defaultChecked = false,
  onChange,
  children,
  styleContainer,
  ...props
}) => {
  const [internalChecked, setInternalChecked] = React.useState(!!defaultChecked);
  const isControlled = typeof checked === "boolean";
  const actualChecked = isControlled ? checked : internalChecked;

  const handleChange = (e) => {
    console.log("Checkbox: handleChange internal", { checked: e?.target?.checked, name: props.name });
    if (!isControlled) setInternalChecked(!!e?.target?.checked);
    if (onChange) onChange(e);
  };

  return (
    <label style={{ ...styleContainer, display: "flex", alignItems: "flex-start" }}>
      <CheckboxStyle className={className} alert={props.alert}>
        <HiddenCheckbox {...props} checked={actualChecked} onChange={handleChange} />
        <StyledCheckbox checked={actualChecked} alert={props.alert}>
          <Icon viewBox="0 0 24 24">
            <polyline points="20 6 9 17 4 12" />
          </Icon>
        </StyledCheckbox>
      </CheckboxStyle>
      <span>{children}</span>
    </label>
  );
};
export default Checkbox;

const CheckboxStyle = styled.div`
  display: inline-block;
  vertical-align: middle;
  margin-right: 8px;
  margin-top: 2px;

  & ~ span {
    font-size: 14px;
    user-select: none;
    font-weight: normal;
    font-family: "Poppins Regular";
    color: ${({ theme, alert }) => (alert ? theme.color.danger : theme.color.lighterText)};
  }
`;

const Icon = styled.svg`
  fill: none;
  stroke: white;
  stroke-width: 2px;
`;

const HiddenCheckbox = styled.input.attrs({ type: "checkbox" })`
  /* Visually hide, keep accessible for screen readers/keyboard */
  border: 0;
  clip: rect(0 0 0 0);
  clip-path: inset(50%);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  white-space: nowrap;
  width: 1px;
  opacity: 0;
`;

const StyledCheckbox = styled.div`
  width: 16px;
  height: 16px;
  background: ${(props) =>
    props.checked
      ? props.theme.color.primary
      : props.alert
        ? "rgba(238, 76, 80, 0.1)"
        : props.theme.color.secondaryBg};
  border-radius: 3px;
  transition: all 150ms;

  ${HiddenCheckbox}:focus + & {
    box-shadow: 0 0 0 2px ${(props) => props.theme.color.primary};
  }

  ${Icon} {
    visibility: ${(props) => (props.checked ? "visible" : "hidden")};
  }
`;
